import i18next from 'i18next';

import { setLanguage } from '@egr/xbox/base-app/i18n';
import { getEnvArray } from '@egr/xbox/utils/ReactScriptHelper';
import { PersistentStore } from '@egr/xbox/utils/store/PersistentStore';

interface LanguageState {
    language: string;
}

export class LanguageStore extends PersistentStore<LanguageState> {
    public userLanguageOptions: ReadonlyArray<string> = getEnvArray('USER_LANGUAGES');

    constructor() {
        super(
            'language',
            {
                language: navigator.language.split('-')[0]
            }
        );
    }

    public updateLanguage(newLanguage: string): void {
        void setLanguage(newLanguage);
        this.updateState({ language: newLanguage });
    }

    public getSelectedLanguage(urlLanguage: string | null): string {
        return urlLanguage || this.snapshot.language || i18next.languages[0];
    }
}

export const languageStore = new LanguageStore();
